import React, { useState, useEffect } from 'react';
import { PRIORITY_OPTIONS, loadPrefs, savePrefs, clearPrefs } from '../utils/matching';

export function PreferencesModal({ theme, open, onClose, onSaved }) {
  const C = (k) => {
    const d = theme === 'dark';
    const m = {
      surf:d?'#141924':'#FFFAF5',
      surf2:d?'rgba(255,255,255,0.03)':'rgba(139,92,246,0.04)',
      bord:d?'rgba(255,255,255,0.07)':'rgba(139,92,246,0.10)',
      bord2:d?'rgba(255,255,255,0.12)':'rgba(139,92,246,0.14)',
      txt:d?'#ffffff':'#1E1048',
      txt2:d?'rgba(255,255,255,0.5)':'#4B3D7A',
      txt3:d?'rgba(255,255,255,0.25)':'#9B8FBD',
      inp:d?'rgba(255,255,255,0.05)':'rgba(139,92,246,0.06)',
    };
    return m[k]||'';
  };
  const [childAge, setChildAge] = useState('');
  const [maxBudget, setMaxBudget] = useState('');
  const [priorities, setPriorities] = useState([]);

  useEffect(() => {
    if (open) {
      const p = loadPrefs() || {};
      setChildAge(p.childAge != null ? String(p.childAge) : '');
      setMaxBudget(p.maxBudget != null ? String(p.maxBudget) : '');
      setPriorities(Array.isArray(p.priorities) ? p.priorities : []);
    }
  }, [open]);

  if (!open) return null;

  const togglePriority = (id) => {
    setPriorities(prev => prev.includes(id) ? prev.filter(x=>x!==id) : (prev.length<5 ? [...prev,id] : prev));
  };

  const handleSave = () => {
    const prefs = {
      childAge: childAge ? Number(childAge) : null,
      maxBudget: maxBudget ? Number(maxBudget) : null,
      priorities,
    };
    savePrefs(prefs);
    if (onSaved) onSaved(prefs);
    onClose();
  };

  const handleClear = () => {
    clearPrefs();
    setChildAge(''); setMaxBudget(''); setPriorities([]);
    if (onSaved) onSaved(null);
    onClose();
  };

  return (
    <div onClick={onClose} style={{position:'fixed',inset:0,zIndex:1500,background:'rgba(0,0,0,0.75)',backdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div onClick={e=>e.stopPropagation()} style={{background:C('surf'),borderRadius:20,maxWidth:440,width:'100%',maxHeight:'90vh',overflowY:'auto',border:'1px solid '+C('bord'),boxShadow:'0 24px 64px rgba(0,0,0,0.5)',padding:'24px 22px 20px'}}>
        <div style={{textAlign:'center',marginBottom:18}}>
          <div style={{fontSize:36,marginBottom:8}}>🎯</div>
          <div style={{color:C('txt'),fontSize:17,fontWeight:800,fontFamily:'Syne,sans-serif',marginBottom:4}}>Sana özel uygunluk skoru</div>
          <div style={{color:C('txt2'),fontSize:12,lineHeight:1.5}}>Tercihini söyle, her okula 0-100 arası uygunluk rozeti gösterelim. Verin sadece tarayıcında saklanır.</div>
        </div>

        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,color:C('txt3'),fontWeight:700,letterSpacing:'0.06em',marginBottom:6}}>ÇOCUĞUNUN YAŞI</div>
          <input type="number" min="0" max="18" value={childAge} onChange={e=>setChildAge(e.target.value)} placeholder="örn. 4"
            style={{width:'100%',background:C('inp'),border:'1px solid '+C('bord'),borderRadius:10,padding:'11px 14px',color:C('txt'),fontSize:14,outline:'none',fontFamily:'DM Sans,sans-serif',boxSizing:'border-box'}}/>
        </div>

        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,color:C('txt3'),fontWeight:700,letterSpacing:'0.06em',marginBottom:6}}>MAKSİMUM AYLIK BÜTÇEN</div>
          <div style={{position:'relative'}}>
            <span style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:C('txt2'),fontSize:14,fontWeight:600,pointerEvents:'none'}}>₺</span>
            <input type="number" min="0" step="500" value={maxBudget} onChange={e=>setMaxBudget(e.target.value)} placeholder="örn. 20.000"
              style={{width:'100%',background:C('inp'),border:'1px solid '+C('bord'),borderRadius:10,padding:'11px 14px 11px 30px',color:C('txt'),fontSize:14,outline:'none',fontFamily:'DM Sans,sans-serif',boxSizing:'border-box'}}/>
          </div>
        </div>

        <div style={{marginBottom:18}}>
          <div style={{fontSize:11,color:C('txt3'),fontWeight:700,letterSpacing:'0.06em',marginBottom:8}}>SENİN İÇİN ÖNEMLİ OLANLAR <span style={{color:C('txt3'),fontWeight:400}}>(en fazla 5)</span></div>
          <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
            {PRIORITY_OPTIONS.map(o => {
              const sel = priorities.includes(o.id);
              return (
                <button key={o.id} onClick={()=>togglePriority(o.id)}
                  style={{padding:'8px 12px',borderRadius:20,background:sel?'rgba(168,218,255,0.18)':C('surf2'),border:'1px solid '+(sel?'rgba(168,218,255,0.5)':C('bord')),color:sel?'#A8DAFF':C('txt2'),fontSize:12,fontWeight:sel?700:500,cursor:'pointer',fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'}}>
                  {o.label}
                </button>
              );
            })}
          </div>
        </div>

        <div style={{display:'flex',gap:8}}>
          <button onClick={handleClear} style={{padding:'12px 16px',borderRadius:10,background:'transparent',border:'1px solid '+C('bord'),color:C('txt2'),fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
            Temizle
          </button>
          <button onClick={handleSave} style={{flex:1,padding:'12px 16px',borderRadius:10,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#000',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
            Tercihimi Kaydet
          </button>
        </div>
      </div>
    </div>
  );
}
